
define('text!templates/modules/setting/business/modals/payment-delete-method-modal.html',[],function () { return '<p class="text-center">{{#t}}payment:deleting_payment_method_message{{/t}}&nbsp<span class="fa fa-spinner fa-pulse fa-1x fa-fw"></span>\n</p>\n';});

